import { CLEAR_VITALS, GET_VITAL_DATA, GET_VITAL_LIST_DATA, SET_VITAL_LOADING } from './vitalList.type'
import axios from 'axios'
import { toggleDeactivateModal, toggleSessionModal } from '../modals/toggleModal.actions'

export const getVitalListData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_VITAL_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/vitals/list`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_VITAL_LIST_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
        })
}

export const getVitalData = (payload, token) => async (dispatch) => {
    dispatch({
        type: SET_VITAL_LOADING,
        payload: true,
    })
    axios
        .post(`${process.env.REACT_APP_CARD_URL}/vitals/view`, payload, {
            headers: {
                accessToken: token,
            },
        })
        .then((response) => {
            if (response.data.status === 200) {
                dispatch({
                    type: GET_VITAL_DATA,
                    payload: response.data.output,
                })
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 401) {
                dispatch(toggleSessionModal(true, response?.data?.error))
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            } else if (response.data.status === 403) {
                dispatch(toggleDeactivateModal(true))
                dispatch({
                    type: SET_VITAL_LOADING,
                    payload: false,
                })
            }
        })
        .catch((err) => {
            // console.log(err)
            dispatch({
                type: SET_VITAL_LOADING,
                payload: false,
            })
        })
}

export const setVitalLoading = (payload) => (dispatch) => {
    dispatch({
        type: SET_VITAL_LOADING,
        payload: payload,
    })
}

export const clearVitals = () => (dispatch) => {
    dispatch({
        type: CLEAR_VITALS,
    })
}
